<!-- 选择学员或输入持卡人 -->
<template>
  <el-form-item>
    <template #label>
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          {{ label }}<el-icon class="el-icon-arrow-down"></el-icon>：
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="学员">学员</el-dropdown-item>
            <el-dropdown-item command="持卡人">持卡人</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </template>
    <yx-student-selector
      v-if="label === '学员'"
      v-bind="config"
      @select="select"
      ref="child"
      @clear="clear"
      width="222px"
      :appendFlag="appendFlag">
      <template #append v-if="appendFlag">
        <slot name="append"><div style="cursor: pointer;" @click="chooseStudent">选择</div></slot>
      </template>
    </yx-student-selector>
    <!-- <el-input
      :modelValue="studentName"
      :placeholder="config.placeholder || '请选择'"
      clearable @focus="chooseStudent"
      @clear="chooseStudent('clear')"
      v-if="label === '学员'"
    ></el-input> -->
    <el-input v-if="label === '持卡人'" v-model="student" placeholder="请输入" clearable></el-input>
  </el-form-item>
</template>

<script>
import { inject, onMounted, ref, watch, computed } from 'vue';

export default {
  kind: 'yq-学员或持卡人',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ([]),
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    appendFlag: {
      type: Boolean,
      default: false,
    },
    campusIds: {
      type: Array,
      default: () => [],
    },
    campusnode: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');
    const label = ref('学员');
    const popup = inject('popup');

    function reset() {
      // eslint-disable-next-line no-use-before-define
      student.value = label.value === '持卡人' ? '' : props.value;
      if (props.value.id) {
        child.value?.setField(props.value.name);
      } else {
        child.value?.clearField();
      }
    }

    function clear() {
      // eslint-disable-next-line no-use-before-define
      student.value = label.value === '持卡人' ? '' : [];
      child.value?.clearField();
    }
    const student = useQuery('student', props.value, reset);

    if (props.value.id) {
      onMounted(() => {
        child.value?.setField(props.value.name);
      });
    }

    function select(obj) {
      student.value = [obj];
    }

    // 选择学员
    async function chooseStudent(type) {
      const node = props.campusnode;
      let campus = props.campusIds;
      if (node && node.child) {
        campus = node.child.campus;
      }
      if (type === 'clear') {
        student.value = [];
      } else {
        const res = await popup('student-chooser', {
          multiple: props.config.multiple,
          lists: student.value,
          campusIds: campus,
        });
        student.value = res;
        child.value?.setField(res.map((i) => i.name).join());
      }
    }

    // 获取学员名字
    const studentName = computed(() => {
      const txt = student.value.map((i) => i.name);
      return txt;
    });

    watch(() => label.value, clear);

    return {
      select,
      child,
      chooseStudent,
      studentName,
      reset,
      clear,
      label,
      student,
      handleCommand(cmd) {
        label.value = cmd;
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.el-dropdown-link {
  font-size: 14px;
  line-height: 32px;
}
</style>
